const getters = {
  getTags: (state) => state.tags,
};

export default getters;
